import axiosInstance from "../../axiosInstance.js";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { resetTeacherProfile } from "../teacher/slice.js";

export const registerTeacher = createAsyncThunk(
  "authTeacher/register",
  async ({ email, password, lang }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post("/teacher/register", {
        email,
        password,
        lang,
      });

      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Registration failed"
      );
    }
  }
);
export const loginTeacher = createAsyncThunk(
  "authTeacher/login",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post("/teacher/login", {
        email,
        password,
      });
      // console.log(data);
      localStorage.setItem("userRole", data.role);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Login failed");
    }
  }
);

export const refreshToken = createAsyncThunk(
  "authTeacher/refresh",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/teacher/refresh");
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        return rejectWithValue(null); // expected
      }
      return rejectWithValue(
        error.response?.data?.message || "Token refresh failed"
      );
    }
  }
);

export const logoutTeacher = createAsyncThunk(
  "authTeacher/logout",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      dispatch(resetTeacherProfile());
      await axiosInstance.post("/teacher/logout"); // ничего не передаём
      localStorage.removeItem("userRole");
      return null;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Logout failed");
    }
  }
);

export const getTeacherProfile = createAsyncThunk(
  "authTeacher/getTeacherProfile",
  async (_, thunkAPI) => {
    try {
      const { data } = await axiosInstance.get("/teacher/profile");
      // console.log(data);

      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Failed to load teacher profile"
      );
    }
  }
);

export const loginTeacherWithGoogle = createAsyncThunk(
  "authTeacher/loginTeacherWithGoogle",
  async (code, thunkAPI) => {
    try {
      const { data } = await axiosInstance.post("/teacher/google-login", {
        code,
      });
      // console.log(data);
      localStorage.setItem("userRole", data.role);
      return data;
    } catch (error) {
      // console.log(error);

      return thunkAPI.rejectWithValue(
        error.response.data.message || "Google login failed"
      );
    }
  }
);

export const verifyTeacherEmailOperation = createAsyncThunk(
  "authTeacher/verifyEmail",
  async (token, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(
        `/auth/verify-teacher-email?token=${token}`,
        { withCredentials: true }
      );
      // console.log(data);
      localStorage.setItem("userRole", data.role);
      return data.teacherToken;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Ошибка подтверждения email"
      );
    }
  }
);
